import { useState, useContext, useEffect } from 'react';
import { Form } from 'react-bootstrap';
import { AiOutlineSearch } from 'react-icons/ai';
import { Button, DateInput, SelectGeneric } from 'ypf-pas-general-ui-components';
import { useFormik } from 'formik';
import PropTypes from 'prop-types';

import { FilesSdsPtContext } from '../../../../../../context/FilesSdsPtContext';
import useToast from '../../../../../../hooks/useToast';
import './FilesFilters.scss';
import { formatAmountDateBack } from '../../../../../../utils/formatUtils';

const FilesFilters = ({ details }) => {
  const { dateFilterRange, getDataFilesPt, getSelectOptionsMonthlyLocationFiles } =
    useContext(FilesSdsPtContext);
  const [locationOptions, setLocationOptions] = useState([]);
  const { setNewToast, closeToast } = useToast();

  const isMsds = (details?.tipoAsignacion?.id || details?.requestData?.tipoAsignacion) === 3;
  const { startDateLimit, finalDateLimit } = dateFilterRange;

  const handleSearch = async (newValues) => {
    const { tipoAsignacion, id } = details;

    try {
      const body = {
        tipoAsignacion: tipoAsignacion?.id,
        filtroArchivosAdjuntos: {
          fechaDesde: newValues.fromDate,
          fechaHasta: newValues.toDate,
          ubicacion: isMsds ? newValues.location?.nombre : null
        }
      };

      await getDataFilesPt(id, body);
    } catch (error) {
      setNewToast({
        type: 'ERROR',
        message: error.message
      });
      closeToast();
    }
  };
  const initialFormValues = {
    location: null,
    fromDate: '',
    toDate: ''
  };
  const formik = useFormik({
    initialValues: initialFormValues,
    onSubmit: (values) => handleSearch(values)
  });

  const { handleSubmit, setFieldValue, values, setValues } = formik;
  const hasSelectedToDate = values.toDate || finalDateLimit;
  const hasSelectedFromDate = values.fromDate || startDateLimit;
  const disabledSearchButton = !(hasSelectedToDate && hasSelectedFromDate);

  const handleGetOptionsMonthlyLocationFiles = async (query) => {
    if (query.length < 3) return;
    const options = await getSelectOptionsMonthlyLocationFiles(details?.id, query);

    setLocationOptions(options);

    // eslint-disable-next-line consistent-return
    return options;
  };

  useEffect(() => {
    if (startDateLimit?.length && finalDateLimit?.length)
      setValues({
        location: null,
        fromDate: startDateLimit,
        toDate: finalDateLimit
      });
  }, [startDateLimit, finalDateLimit, setValues]);

  return (
    <Form onSubmit={handleSubmit}>
      <div className="d-flex pt-2">
        <div className="d-flex">
          <span className="text-bold p-2 fw-bolder fs-6">Desde</span>
          <DateInput
            max={finalDateLimit}
            min={startDateLimit}
            name="fromDate"
            onChange={(newValue) =>
              setFieldValue('fromDate', formatAmountDateBack(newValue.target.value))
            }
            onClear={() => setFieldValue('fromDate', '')}
            value={values.fromDate}
          />
        </div>
        <div className="d-flex">
          <span className="text-bold p-2 fw-bolder fs-6">Hasta</span>
          <DateInput
            max={finalDateLimit}
            min={startDateLimit}
            name="toDate"
            onChange={(newValue) =>
              setFieldValue('toDate', formatAmountDateBack(newValue.target.value))
            }
            onClear={() => setFieldValue('toDate', '')}
            value={values.toDate}
          />
        </div>
        {isMsds && (
          <div className="d-flex">
            <span className="text-bold p-2 fw-bolder fs-6">Ubicacion</span>
            <SelectGeneric
              async
              clearable
              defaultValueOneOption={false}
              fetchData={(value) => handleGetOptionsMonthlyLocationFiles(value)}
              name="location"
              noOptionsMessage="Ingresar al menos 3 caracteres"
              onChange={(newValue) => {
                setFieldValue('location', newValue);
                if (newValue === null) handleSearch({ ...values, location: null });
              }}
              options={locationOptions}
              value={values.location}
            />
          </div>
        )}
        <div className="d-flex">
          <Button
            className="search-files-button"
            disabled={disabledSearchButton}
            icon={AiOutlineSearch}
            onClick={() => handleSearch(values)}
            sizeIcon="20px"
            type="button"
            variant="outline-primary"
            widthButton="38px"
          />
        </div>
      </div>
    </Form>
  );
};

FilesFilters.propTypes = {
  details: PropTypes.oneOfType.isRequired
};

FilesFilters.defaultProps = {};

export default FilesFilters;
